import { ref, computed } from 'vue';

export default function useEditorSaveStatus() {
  const originalYamlRef = ref<string>();
  const lastSavedYamlRef = ref<string>();
  const lastCommittedYamlRef = ref<string>();
  const lastTouchedYamlRef = ref<string>();

  const originalCssRef = ref<string>();
  const lastSavedCssRef = ref<string>();
  const lastCommittedCssRef = ref<string>();
  const lastTouchedCssRef = ref<string>();

  const dirty = computed(
    () =>
      lastSavedYamlRef.value !== lastTouchedYamlRef.value ||
      lastSavedCssRef.value !== lastTouchedCssRef.value
  );
  const error = ref<string>();

  const hasUncommittedChanges = computed(
    () =>
      lastCommittedYamlRef.value !== lastTouchedYamlRef.value ||
      lastCommittedCssRef.value !== lastTouchedCssRef.value
  );

  const newCommitSaved = computed(
    () =>
      lastCommittedYamlRef.value === lastTouchedYamlRef.value &&
      lastCommittedCssRef.value === lastTouchedCssRef.value &&
      (originalYamlRef.value !== lastCommittedYamlRef.value ||
        originalCssRef.value !== lastCommittedCssRef.value) &&
      !dirty.value
  );

  // TODO show draft saved if last commit is older than last draft
  const draftSaved = computed(
    () =>
      lastSavedYamlRef.value === lastTouchedYamlRef.value &&
      lastSavedCssRef.value === lastTouchedCssRef.value &&
      (originalYamlRef.value !== lastTouchedYamlRef.value ||
        originalCssRef.value !== lastTouchedCssRef.value)
  );

  const onCommit = async () => {
    lastCommittedYamlRef.value = lastTouchedYamlRef.value;
    lastCommittedCssRef.value = lastTouchedCssRef.value;
  };

  return {
    originalYamlRef,
    lastSavedYamlRef,
    lastCommittedYamlRef,
    lastTouchedYamlRef,
    originalCssRef,
    lastSavedCssRef,
    lastCommittedCssRef,
    lastTouchedCssRef,
    dirty,
    error,
    hasUncommittedChanges,
    newCommitSaved,
    draftSaved,
    onCommit
  };
}
